interface MyObject {
  [key: string]: string[];
}

const titles: MyObject = {
  day: ['день', 'дня', 'дней'],
  request: ['запрос', 'запроса', 'запросов'],
  calculation: ['расчет', 'расчета', 'расчетов'],
  object: ['объект', 'объекта', 'объектов'],
  project: ['проект', 'проекта', 'проектов'],
};

export const declination = (key: string, count: number) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return `${count} ${
    titles[key][
      count % 100 > 4 && count % 100 < 20
        ? 2
        : cases[count % 10 < 5 ? count % 10 : 5]
    ]
  }`;
};
